<script lang="ts">
  // Reusable promo card for the free Beta phase. Renders only when the runtime
  // flag is on, so it disappears site-wide when the flag is OFF. Designed to be
  // dropped into a page's <main>.
  import { Link } from "svelte-routing";
  import { betaEnabled } from "./beta";
</script>

{#if $betaEnabled}
  <section class="section section--tight" data-testid="beta-callout">
    <div class="wrap">
      <div class="beta-callout">
        <span class="eyebrow">Beta-Phase</span>
        <h2 class="beta-callout__title">Jetzt kostenlos mit testen</h2>
        <div class="prose">
          <p>
            Während der Beta hosten wir den Server für euch
            <strong>komplett kostenlos</strong>. Wir suchen Schulen, Familien und
            Technik-Begeisterte, die wiederdabei ausprobieren und uns ehrliches
            Feedback geben — so machen wir das Projekt gemeinsam besser.
          </p>
        </div>
        <Link to="/beta" class="btn btn--primary">Bei der Beta mitmachen →</Link>
      </div>
    </div>
  </section>
{/if}

<style>
  .beta-callout {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    padding: clamp(24px, 4vw, 36px);
    box-shadow: var(--shadow-sm);
    display: grid;
    gap: 14px;
    justify-items: start;
  }
  .beta-callout__title {
    font-size: clamp(24px, 3.2vw, 34px);
    letter-spacing: -0.025em;
  }
  .beta-callout .prose {
    max-width: 62ch;
  }
</style>
